export const PHONE_PATTERN = /^1[3-9]\d{9}$/

export function isPhone(value) {
  return PHONE_PATTERN.test(String(value || '').trim())
}

export function isEmail(value) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim())
}

export function isFixedSmsCode(value) {
  return String(value || '').trim() === '123456'
}

export function isFixedImageCode(value) {
  return String(value || '').trim().toLowerCase() === 'ascyaf'
}

export function isAdminAccount(username, password) {
  return String(username || '').trim() === 'admin' && String(password || '').trim() === 'admin'
}
